<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

const store = useStore()
const route = useRoute()

const schematisationDrawer = computed(() => store.state.project.schematisationDrawer)

const toggleSchematisationDrawer = () => store.dispatch('project/toggleSchematisationDrawer')

const shownRightSideBarButton = computed(() => route.meta.sideBarRight)

const icon = computed(() => {
  return schematisationDrawer.value ? 'mdi-close' : 'mdi-menu'
})
</script>

<template>
  <v-btn size="small" icon v-if="shownRightSideBarButton" color="white">
    <v-icon style="color: white" @click="toggleSchematisationDrawer">{{ icon }}</v-icon>
  </v-btn>
</template>
